import React from 'react';
import { Globe } from 'lucide-react';
import { SectionTitle } from '../ui/CommonComponents';
import RevealOnScroll from '../../hooks/useRevealOnScroll';
import { useTranslation } from '../../hooks/useTranslation';

export const AboutSection = () => {
    const { t } = useTranslation();

    return (
        <section id="about" className="py-20 px-6 bg-[#0d0d0d] relative">
            <div className="container mx-auto">
                <RevealOnScroll>
                    <SectionTitle title={t('aboutTitle')} subtitle={t('aboutSubtitle')} />
                </RevealOnScroll>

                <div className="grid md:grid-cols-3 gap-12">
                    <div className="md:col-span-2 space-y-6 text-lg text-[#7b7b7b] leading-relaxed">
                        <RevealOnScroll delay={100}>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutText1') }} />
                        </RevealOnScroll>
                        <RevealOnScroll delay={200}>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutText2') }} />
                        </RevealOnScroll>
                        <RevealOnScroll delay={300}>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutText3') }} />
                        </RevealOnScroll>
                    </div>

                    <div className="relative">
                        <RevealOnScroll delay={400}>
                            <div className="space-y-8">
                                <div className="bg-[#141414] p-6 rounded-xl border border-[#732424]/30">
                                    <h3 className="text-white font-bold mb-4 flex items-center gap-2">
                                        <Globe className="w-5 h-5 text-[#d92323]" /> {t('languagesTitle')}
                                    </h3>
                                    <div className="space-y-3">
                                        <div className="flex justify-between text-sm">
                                            <span>{t('englishLevel')}</span>
                                            <span className="text-[#d92323]">96/120</span>
                                        </div>
                                        <div className="w-full bg-[#0d0d0d] h-2 rounded-full overflow-hidden">
                                            <div className="h-full bg-[#d92323] w-[80%]"></div>
                                        </div>
                                        <div className="flex justify-between text-sm">
                                            <span>{t('frenchLanguage')}</span>
                                            <span className="text-[#d92323]">{t('fluentLevel')}</span>
                                        </div>
                                        <div className="w-full bg-[#0d0d0d] h-2 rounded-full overflow-hidden">
                                            <div className="h-full bg-[#d92323] w-[70%]"></div>
                                        </div>
                                        <div className="flex justify-between text-sm">
                                            <span>{t('arabicLanguage')}</span>
                                            <span className="text-[#d92323]">{t('nativeLevel')}</span>
                                        </div>
                                        <div className="w-full bg-[#0d0d0d] h-2 rounded-full overflow-hidden">
                                            <div className="h-full bg-[#d92323] w-[100%]"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </RevealOnScroll>
                    </div>
                </div>
            </div>
        </section>
    );
};